import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { classNames } from '@axo/shared/util/dom';
import { useCloseApplication } from '../../../hooks/navigation/useCloseApplication';
import { ApplicationContext } from '../../../store/context';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

export function useOpenApplicationsNodes(marketCountry: string): MenuNode[] {
  const { state } = useContext(ApplicationContext);

  const apps = useMemo(
    () => Object.values(state.openApplications),
    [state.openApplications],
  );

  const navigate = useNavigate();

  const { closeAndUnlockMultiple } = useCloseApplication(marketCountry);

  const nodes = useMemo<MenuNode[]>(
    () => [
      ...apps.map<MenuNode>((app) => ({
        id: 'open-applications/' + app.applicationID,
        label: app.humanReadableID,
        className: styles.clickable,
        nodeData: {
          onClick: () => navigate(`/application/${app.applicationID}`),
        },
      })),
      {
        id: '6630F7A6-9FC3-4FF7-A810-E126FFB29191',
        hasCaret: false,
        label: 'Close all applications',
        icon: 'cross',
        disabled: apps.length === 0,
        className: classNames(styles.clickable, styles.action),
        nodeData: {
          onClick: () =>
            closeAndUnlockMultiple(apps.map((app) => app.applicationID)),
        },
      },
    ],
    [apps, navigate, closeAndUnlockMultiple],
  );

  return useMemo(
    () => [
      {
        id: '08D08292-3131-4E95-B262-A697F14510C4',
        hasCaret: true,
        icon: 'blocked-person',
        label: 'Open applications',
        secondaryLabel: `(${apps.length})`,
        className: styles.clickable,
        childNodes: nodes,
      },
    ],
    [nodes, apps.length],
  );
}
